import * as __SNOWPACK_ENV__ from '../../../_snowpack/env.js';

import './SearchExcerpt.svelte.css';
/* src/components/searchList/SearchExcerpt.svelte generated by Svelte v3.46.4 */
import {
	SvelteComponent,
	add_render_callback,
	append,
	attr,
	check_outros,
	component_subscribe,
	create_bidirectional_transition,
	create_component,
	destroy_component,
	destroy_each,
	detach,
	element,
	group_outros,
	init,
	insert,
	listen,
	mount_component,
	noop,
	run_all,
	safe_not_equal,
	self,
	set_data,
	set_store_value,
	set_style,
	space,
	src_url_equal,
	text,
	transition_in,
	transition_out
} from "../../../_snowpack/pkg/svelte/internal.js";

import { onMount } from '../../../_snowpack/pkg/svelte.js';
import { blur, fade } from '../../../_snowpack/pkg/svelte/transition.js';
import { getSearchExcerptList } from '../../stores/libREST.js';

import {
	inputValues,
	defaultParams,
	setCurrentParams
} from '../../stores/storeInputOptions.js';

import SearchListControl from './SearchListControl.svelte.js';
import SearchLoading from '../searchResult/SearchLoading.svelte.js';
import { getDestinationPointY } from './searchList.js';

function get_each_context(ctx, list, i) {
	const child_ctx = ctx.slice();
	child_ctx[15] = list[i];
	child_ctx[17] = i;
	return child_ctx;
}

// (104:1) {:else}
function create_else_block(ctx) {
	let div2;
	let div0;
	let img;
	let img_src_value;
	let t0;
	let div1;
	let h2;
	let t1_value = /*detailView*/ ctx[1][5] + "";
	let t1;
	let t2;
	let br;
	let t3;
	let ruby;
	let rb;
	let t4_value = /*detailView*/ ctx[1][6] + "";
	let t4;
	let t5;
	let rp0;
	let t7;
	let rt;
	let t8_value = /*detailView*/ ctx[1][9] + "";
	let t8;
	let t9;
	let rp1;
	let t11;
	let t12_value = /*detailView*/ ctx[1][7] + "";
	let t12;
	let t13_value = /*detailView*/ ctx[1][8] + "";
	let t13;
	let t14;
	let p;
	let t15_value = /*detailView*/ ctx[1][10] + "";
	let t15;

	return {
		c() {
			div2 = element("div");
			div0 = element("div");
			img = element("img");
			t0 = space();
			div1 = element("div");
			h2 = element("h2");
			t1 = text(t1_value);
			t2 = space();
			br = element("br");
			t3 = space();
			ruby = element("ruby");
			rb = element("rb");
			t4 = text(t4_value);
			t5 = space();
			rp0 = element("rp");
			rp0.textContent = "《";
			t7 = space();
			rt = element("rt");
			t8 = text(t8_value);
			t9 = space();
			rp1 = element("rp");
			rp1.textContent = "》";
			t11 = space();
			t12 = text(t12_value);
			t13 = text(t13_value);
			t14 = space();
			p = element("p");
			t15 = text(t15_value);
			if (!src_url_equal(img.src, img_src_value = /*detailView*/ ctx[1][4])) attr(img, "src", img_src_value);
			attr(img, "alt", "");
			attr(img, "loading", "lazy");
			attr(img, "class", "svelte-1365l8");
			attr(div0, "class", "search-excerpt-image svelte-1365l8");
			set_style(div0, "background-image", "url(" + /*bgURL*/ ctx[6] + "bg_visual.jpg)");
			attr(rb, "class", "rb");
			attr(rp0, "class", "rp");
			attr(rt, "class", "rt");
			attr(rp1, "class", "rp");
			attr(ruby, "class", "ruby");
			attr(h2, "class", "svelte-1365l8");
			attr(p, "class", "svelte-1365l8");
			attr(div1, "class", "search-excerpt-content svelte-1365l8");
			attr(div2, "id", "Search-Excerpt-Detail");
			attr(div2, "class", "search-excerpt-detail svelte-1365l8");
			attr(div2, "style", /*backgroundStyle*/ ctx[7]);
		},
		m(target, anchor) {
			insert(target, div2, anchor);
			append(div2, div0);
			append(div0, img);
			append(div2, t0);
			append(div2, div1);
			append(div1, h2);
			append(h2, t1);
			append(h2, t2);
			append(h2, br);
			append(h2, t3);
			append(h2, ruby);
			append(ruby, rb);
			append(rb, t4);
			append(ruby, t5);
			append(ruby, rp0);
			append(ruby, t7);
			append(ruby, rt);
			append(rt, t8);
			append(ruby, t9);
			append(ruby, rp1);
			append(h2, t11);
			append(h2, t12);
			append(h2, t13);
			append(div1, t14);
			append(div1, p);
			append(p, t15);
		},
		p(ctx, dirty) {
			if (dirty & /*detailView*/ 2 && !src_url_equal(img.src, img_src_value = /*detailView*/ ctx[1][4])) {
				attr(img, "src", img_src_value);
			}

			if (dirty & /*detailView*/ 2 && t1_value !== (t1_value = /*detailView*/ ctx[1][5] + "")) set_data(t1, t1_value);
			if (dirty & /*detailView*/ 2 && t4_value !== (t4_value = /*detailView*/ ctx[1][6] + "")) set_data(t4, t4_value);
			if (dirty & /*detailView*/ 2 && t8_value !== (t8_value = /*detailView*/ ctx[1][9] + "")) set_data(t8, t8_value);
			if (dirty & /*detailView*/ 2 && t12_value !== (t12_value = /*detailView*/ ctx[1][7] + "")) set_data(t12, t12_value);
			if (dirty & /*detailView*/ 2 && t13_value !== (t13_value = /*detailView*/ ctx[1][8] + "")) set_data(t13, t13_value);
			if (dirty & /*detailView*/ 2 && t15_value !== (t15_value = /*detailView*/ ctx[1][10] + "")) set_data(t15, t15_value);
		},
		i: noop,
		o: noop,
		d(detaching) {
			if (detaching) detach(div2);
		}
	};
}

// (88:1) {#if !detailView.length}
function create_if_block_2(ctx) {
	let div;
	let img;
	let img_src_value;
	let div_transition;
	let current;

	return {
		c() {
			div = element("div");
			img = element("img");
			attr(img, "class", "default-img svelte-1365l8");
			if (!src_url_equal(img.src, img_src_value = /*eyecatch*/ ctx[0])) attr(img, "src", img_src_value);
			attr(img, "alt", "");
			attr(img, "width", "302");
			attr(img, "height", "463");
			attr(img, "loading", "lazy");
			attr(div, "id", "Search-Excerpt-Detail");
			attr(div, "class", "search-excerpt-default svelte-1365l8");
			attr(div, "style", /*backgroundStyle*/ ctx[7]);
		},
		m(target, anchor) {
			insert(target, div, anchor);
			append(div, img);
			current = true;
		},
		p(ctx, dirty) {
			if (!current || dirty & /*eyecatch*/ 1 && !src_url_equal(img.src, img_src_value = /*eyecatch*/ ctx[0])) {
				attr(img, "src", img_src_value);
			}
		},
		i(local) {
			if (current) return;

			add_render_callback(() => {
				if (!div_transition) div_transition = create_bidirectional_transition(div, fade, { delay: 250, duration: 300 }, true);
				div_transition.run(1);
			});

			current = true;
		},
		o(local) {
			if (!div_transition) div_transition = create_bidirectional_transition(div, fade, { delay: 250, duration: 300 }, false);
			div_transition.run(0);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(div);
			if (detaching && div_transition) div_transition.end();
		}
	};
}

// (134:1) {#if isExcerptLoading && !list.item}
function create_if_block_1(ctx) {
	let div;
	let searchloading;
	let current;
	searchloading = new SearchLoading({});

	return {
		c() {
			div = element("div");
			create_component(searchloading.$$.fragment);
			attr(div, "class", "search-excerpt-loading svelte-1365l8");
		},
		m(target, anchor) {
			insert(target, div, anchor);
			mount_component(searchloading, div, null);
			current = true;
		},
		i(local) {
			if (current) return;
			transition_in(searchloading.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(searchloading.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(div);
			destroy_component(searchloading);
		}
	};
}

// (141:2) {#if list && list.item}
function create_if_block(ctx) {
	let ul;
	let t;
	let searchlistcontrol;
	let ul_transition;
	let current;
	let each_value = /*list*/ ctx[3].item;
	let each_blocks = [];

	for (let i = 0; i < each_value.length; i += 1) {
		each_blocks[i] = create_each_block(get_each_context(ctx, each_value, i));
	}

	searchlistcontrol = new SearchListControl({
			props: {
				disabledprev: /*isExcerptLoading*/ ctx[2] || /*list*/ ctx[3].page.prev < 1,
				disablednext: /*isExcerptLoading*/ ctx[2] || /*list*/ ctx[3].page.next > /*list*/ ctx[3].page.page,
				turn: /*turn*/ ctx[8]
			}
		});

	return {
		c() {
			ul = element("ul");

			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].c();
			}

			t = space();
			create_component(searchlistcontrol.$$.fragment);
			attr(ul, "class", " svelte-1365l8");
		},
		m(target, anchor) {
			insert(target, ul, anchor);

			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].m(ul, null);
			}

			append(ul, t);
			mount_component(searchlistcontrol, ul, null);
			current = true;
		},
		p(ctx, dirty) {
			if (dirty & /*list, URL, changeDetailView*/ 552) {
				each_value = /*list*/ ctx[3].item;
				let i;

				for (i = 0; i < each_value.length; i += 1) {
					const child_ctx = get_each_context(ctx, each_value, i);

					if (each_blocks[i]) {
						each_blocks[i].p(child_ctx, dirty);
					} else {
						each_blocks[i] = create_each_block(child_ctx);
						each_blocks[i].c();
						each_blocks[i].m(ul, t);
					}
				}

				for (; i < each_blocks.length; i += 1) {
					each_blocks[i].d(1);
				}

				each_blocks.length = each_value.length;
			}

			const searchlistcontrol_changes = {};
			if (dirty & /*isExcerptLoading, list*/ 12) searchlistcontrol_changes.disabledprev = /*isExcerptLoading*/ ctx[2] || /*list*/ ctx[3].page.prev < 1;
			if (dirty & /*isExcerptLoading, list*/ 12) searchlistcontrol_changes.disablednext = /*isExcerptLoading*/ ctx[2] || /*list*/ ctx[3].page.next > /*list*/ ctx[3].page.page;
			searchlistcontrol.$set(searchlistcontrol_changes);
		},
		i(local) {
			if (current) return;
			transition_in(searchlistcontrol.$$.fragment, local);

			add_render_callback(() => {
				if (!ul_transition) ul_transition = create_bidirectional_transition(ul, blur, { amount: 10 }, true);
				ul_transition.run(1);
			});

			current = true;
		},
		o(local) {
			transition_out(searchlistcontrol.$$.fragment, local);
			if (!ul_transition) ul_transition = create_bidirectional_transition(ul, blur, { amount: 10 }, false);
			ul_transition.run(0);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(ul);
			destroy_each(each_blocks, detaching);
			destroy_component(searchlistcontrol);
			if (detaching && ul_transition) ul_transition.end();
		}
	};
}

// (143:4) {#each list.item as item, index}
function create_each_block(ctx) {
	let li;
	let a;
	let img;
	let img_src_value;
	let img_alt_value;
	let img_data_value_value;
	let a_href_value;
	let li_id_value;
	let mounted;
	let dispose;

	return {
		c() {
			li = element("li");
			a = element("a");
			img = element("img");
			if (!src_url_equal(img.src, img_src_value = /*item*/ ctx[15][11])) attr(img, "src", img_src_value);
			attr(img, "alt", img_alt_value = "" + (/*item*/ ctx[15][1] + "_" + /*item*/ ctx[15][2] + "_" + /*item*/ ctx[15][3]));
			attr(img, "width", "100");
			attr(img, "height", "100");
			attr(img, "loading", "lazy");
			attr(img, "data-value", img_data_value_value = /*index*/ ctx[17]);
			attr(img, "class", "svelte-1365l8");
			attr(a, "href", a_href_value = "" + (/*URL*/ ctx[5] + "/" + /*item*/ ctx[15][1] + "_" + /*item*/ ctx[15][2] + "_" + /*item*/ ctx[15][3] + "/"));
			attr(a, "class", "svelte-1365l8");
			attr(li, "id", li_id_value = "id_" + /*item*/ ctx[15][0] + "_" + /*item*/ ctx[15][1] + "_" + /*item*/ ctx[15][2]);
			attr(li, "class", "lit_actype_1 svelte-1365l8");
		},
		m(target, anchor) {
			insert(target, li, anchor);
			append(li, a);
			append(a, img);

			if (!mounted) {
				dispose = [
					listen(img, "mouseover", self(/*changeDetailView*/ ctx[9])),
					listen(img, "focus", self(/*changeDetailView*/ ctx[9]))
				];

				mounted = true;
			}
		},
		p(ctx, dirty) {
			if (dirty & /*list*/ 8 && !src_url_equal(img.src, img_src_value = /*item*/ ctx[15][11])) {
				attr(img, "src", img_src_value);
			}

			if (dirty & /*list*/ 8 && img_alt_value !== (img_alt_value = "" + (/*item*/ ctx[15][1] + "_" + /*item*/ ctx[15][2] + "_" + /*item*/ ctx[15][3]))) {
				attr(img, "alt", img_alt_value);
			}

			if (dirty & /*list*/ 8 && a_href_value !== (a_href_value = "" + (/*URL*/ ctx[5] + "/" + /*item*/ ctx[15][1] + "_" + /*item*/ ctx[15][2] + "_" + /*item*/ ctx[15][3] + "/"))) {
				attr(a, "href", a_href_value);
			}

			if (dirty & /*list*/ 8 && li_id_value !== (li_id_value = "id_" + /*item*/ ctx[15][0] + "_" + /*item*/ ctx[15][1] + "_" + /*item*/ ctx[15][2])) {
				attr(li, "id", li_id_value);
			}
		},
		d(detaching) {
			if (detaching) detach(li);
			mounted = false;
			run_all(dispose);
		}
	};
}

function create_fragment(ctx) {
	let scrolling = false;

	let clear_scrolling = () => {
		scrolling = false;
	};

	let scrolling_timeout;
	let div1;
	let current_block_type_index;
	let if_block0;
	let t0;
	let t1;
	let div0;
	let current;
	let mounted;
	let dispose;
	add_render_callback(/*onwindowscroll*/ ctx[10]);
	const if_block_creators = [create_if_block_2, create_else_block];
	const if_blocks = [];

	function select_block_type(ctx, dirty) {
		if (!/*detailView*/ ctx[1].length) return 0;
		return 1;
	}

	current_block_type_index = select_block_type(ctx, -1);
	if_block0 = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);
	let if_block1 = /*isExcerptLoading*/ ctx[2] && !/*list*/ ctx[3].item && create_if_block_1(ctx);
	let if_block2 = /*list*/ ctx[3] && /*list*/ ctx[3].item && create_if_block(ctx);

	return {
		c() {
			div1 = element("div");
			if_block0.c();
			t0 = space();
			if (if_block1) if_block1.c();
			t1 = space();
			div0 = element("div");
			if (if_block2) if_block2.c();
			attr(div0, "class", "search-excerpt-list svelte-1365l8");
			attr(div0, "id", "Search-Excerpts");
			attr(div1, "class", "search-excerpts svelte-1365l8");
		},
		m(target, anchor) {
			insert(target, div1, anchor);
			if_blocks[current_block_type_index].m(div1, null);
			append(div1, t0);
			if (if_block1) if_block1.m(div1, null);
			append(div1, t1);
			append(div1, div0);
			if (if_block2) if_block2.m(div0, null);
			current = true;

			if (!mounted) {
				dispose = listen(window, "scroll", () => {
					scrolling = true;
					clearTimeout(scrolling_timeout);
					scrolling_timeout = setTimeout(clear_scrolling, 100);
					/*onwindowscroll*/ ctx[10]();
				});

				mounted = true;
			}
		},
		p(ctx, [dirty]) {
			if (dirty & /*windowY*/ 16 && !scrolling) {
				scrolling = true;
				clearTimeout(scrolling_timeout);
				scrollTo(window.pageXOffset, /*windowY*/ ctx[4]);
				scrolling_timeout = setTimeout(clear_scrolling, 100);
			}

			let previous_block_index = current_block_type_index;
			current_block_type_index = select_block_type(ctx, dirty);

			if (current_block_type_index === previous_block_index) {
				if_blocks[current_block_type_index].p(ctx, dirty);
			} else {
				group_outros();

				transition_out(if_blocks[previous_block_index], 1, 1, () => {
					if_blocks[previous_block_index] = null;
				});

				check_outros();
				if_block0 = if_blocks[current_block_type_index];

				if (!if_block0) {
					if_block0 = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);
					if_block0.c();
				} else {
					if_block0.p(ctx, dirty);
				}

				transition_in(if_block0, 1);
				if_block0.m(div1, t0);
			}

			if (/*isExcerptLoading*/ ctx[2] && !/*list*/ ctx[3].item) {
				if (if_block1) {
					if (dirty & /*isExcerptLoading, list*/ 12) {
						transition_in(if_block1, 1);
					}
				} else {
					if_block1 = create_if_block_1(ctx);
					if_block1.c();
					transition_in(if_block1, 1);
					if_block1.m(div1, t1);
				}
			} else if (if_block1) {
				group_outros();

				transition_out(if_block1, 1, 1, () => {
					if_block1 = null;
				});

				check_outros();
			}

			if (/*list*/ ctx[3] && /*list*/ ctx[3].item) {
				if (if_block2) {
					if_block2.p(ctx, dirty);

					if (dirty & /*list*/ 8) {
						transition_in(if_block2, 1);
					}
				} else {
					if_block2 = create_if_block(ctx);
					if_block2.c();
					transition_in(if_block2, 1);
					if_block2.m(div0, null);
				}
			} else if (if_block2) {
				group_outros();

				transition_out(if_block2, 1, 1, () => {
					if_block2 = null;
				});

				check_outros();
			}
		},
		i(local) {
			if (current) return;
			transition_in(if_block0);
			transition_in(if_block1);
			transition_in(if_block2);
			current = true;
		},
		o(local) {
			transition_out(if_block0);
			transition_out(if_block1);
			transition_out(if_block2);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(div1);
			if_blocks[current_block_type_index].d();
			if (if_block1) if_block1.d();
			if (if_block2) if_block2.d();
			mounted = false;
			dispose();
		}
	};
}

function instance($$self, $$props, $$invalidate) {
	let $inputValues;
	let $defaultParams;
	component_subscribe($$self, inputValues, $$value => $$invalidate(12, $inputValues = $$value));
	component_subscribe($$self, defaultParams, $$value => $$invalidate(13, $defaultParams = $$value));
	let { eyecatch } = $$props;
	let detailView = [];
	const URL = __SNOWPACK_ENV__.SNOWPACK_PUBLIC_API_URL;
	const bgURL = URL + '/img/lithos_philia/common/';
	const backgroundStyle = 'background-image: url(' + __SNOWPACK_ENV__.SNOWPACK_PUBLIC_API_URL + '/img/lithos_philia/common/bg_detail.webp);';
	let isExcerptLoading = false;
	let excerptOptions = {};
	let list = $defaultParams.excerptlist;

	onMount(async () => {
		$$invalidate(2, isExcerptLoading = false);
		excerptOptions = $defaultParams.excerpt;

		if (!list) {
			sendOptions();
		}
	});

	/**
 * 検索パラメータを送信して検索結果を更新する
 *
 * @return void
 */
	async function sendOptions() {
		$$invalidate(2, isExcerptLoading = true);
		$$invalidate(1, detailView = []);
		$$invalidate(3, list = {});
		excerptOptions.epid = $inputValues.epid;
		$$invalidate(3, list = await getSearchExcerptList(excerptOptions));
		await setCurrentParams($inputValues);

		//setURLParams($currentParams);
		$$invalidate(2, isExcerptLoading = false);
	}

	let windowY;

	/**
 * ページパラメータを送信して検索結果を更新する
 *
 * @param  object e イベントハンドラ
 * @return void
 */
	function turn(e) {
		$$invalidate(4, windowY = getDestinationPointY(40) ?? windowY);

		if ('next' === e.target.value) {
			set_store_value(inputValues, $inputValues.epid = list.page.next, $inputValues);
		} else if ('prev' === e.target.value) {
			set_store_value(inputValues, $inputValues.epid = list.page.prev, $inputValues);
		} else {
			return;
		}

		sendOptions();
	}

	function changeDetailView(e) {
		$$invalidate(1, detailView = list.item[e.target.dataset.value]);
	}

	function onwindowscroll() {
		$$invalidate(4, windowY = window.pageYOffset)
	}

	$$self.$$set = $$props => {
		if ('eyecatch' in $$props) $$invalidate(0, eyecatch = $$props.eyecatch);
	};

	return [
		eyecatch,
		detailView,
		isExcerptLoading,
		list,
		windowY,
		URL,
		bgURL,
		backgroundStyle,
		turn,
		changeDetailView,
		onwindowscroll
	];
}

class SearchExcerpt extends SvelteComponent {
	constructor(options) {
		super();
		init(this, options, instance, create_fragment, safe_not_equal, { eyecatch: 0 });
	}
}

export default SearchExcerpt;